module.exports = __webpack_public_path__ + "static/media/register-3840w.62ba99b9.jpg";